import React from 'react';
export function DevicePreviews() {
  return <div className="grid gap-10 lg:grid-cols-[390px_1fr] lg:items-start" data-id="element-46" data-mp="2brup4o3ui5rf">
      <figure data-id="element-47" data-mp="1c2asz0h77174">
        <div className="overflow-hidden rounded-[2rem] border-[10px] border-carbon bg-carbon" data-id="element-48" data-mp="1c2szcpxkqvsr">
          <iframe src="/" title="Vista móvil de la página de venta" className="block h-[760px] w-full bg-ivory" style={{
          width: 370
        }} data-id="element-49" data-mp="1q2bwknoukmqa" />
        </div>
        <figcaption className="mt-3 text-sm text-stone" data-id="element-50" data-mp="xefzviza2uti">Móvil · 390 px</figcaption>
      </figure>

      <figure className="min-w-0" data-id="element-51" data-mp="sgwlmj2kyi1k">
        <div className="overflow-hidden rounded-lg border border-sand bg-paper" data-id="element-52" data-mp="173ptj39rsljq">
          <div className="flex items-center gap-1.5 border-b border-sand px-4 py-3" aria-hidden="true" data-id="element-53" data-mp="175suujgdi13r">
            <span className="h-2.5 w-2.5 rounded-full bg-sand" data-id="element-54" data-mp="enov6uq8jslg" />
            <span className="h-2.5 w-2.5 rounded-full bg-sand" data-id="element-55" data-mp="em41167u2bo4" />
            <span className="h-2.5 w-2.5 rounded-full bg-sand" data-id="element-56" data-mp="9pdm4m7rlm4a" />
          </div>
          <div className="relative h-[450px] overflow-hidden" data-id="element-57" data-mp="15q4f41itf2qh">
            <iframe src="/" title="Vista de escritorio de la página de venta" className="absolute left-0 top-0 origin-top-left bg-ivory" style={{
            width: 1440,
            height: 900,
            transform: 'scale(0.5)'
          }} data-id="element-58" data-mp="15pme6rl7k0c8" />
          </div>
        </div>
        <figcaption className="mt-3 text-sm text-stone" data-id="element-59" data-mp="1jghma1nvuder">Escritorio · 1440 px (al 50 %)</figcaption>
      </figure>
    </div>;
}